import { formatEur } from '@/lib/format';
import styles from './Price.module.css';

interface PriceProps {
  amount: number | null;
  size?: 'sm' | 'md' | 'lg';
  muted?: boolean;
  className?: string;
  emptyLabel?: string;
}

export function Price({
  amount,
  size = 'md',
  muted,
  className,
  emptyLabel = '—',
}: PriceProps) {
  const value = amount == null ? emptyLabel : formatEur(amount);
  return (
    <span
      className={[
        styles.price,
        styles[size],
        muted ? styles.muted : '',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {value}
    </span>
  );
}
